import {captureException} from '@sentry/browser';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import {initReactI18next} from 'react-i18next';

import cs_CZ from './locales/cs-CZ.json';
import de_DE from './locales/de-DE.json';
import en_US from './locales/en-GB.json';
import es_ES from './locales/es-ES.json';
import fr_FR from './locales/fr-FR.json';
import it_IT from './locales/it-IT.json';
import pl_PL from './locales/pl-PL.json';
import sk_SK from './locales/sk-SK.json';

const i18n = i18next.createInstance();

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    defaultNS: 'translation',
    ns: ['translation'],
    missingKeyHandler: (lngs, ns, key) => {
      captureException(new Error(`Missing translation key: ${key} in ${window.location.href}`));
      return key;
    },
    resources: {
      cs: {
        translation: cs_CZ,
      },
      de: {
        translation: de_DE,
      },
      en: {
        translation: en_US,
      },
      es: {
        translation: es_ES,
      },
      fr: {
        translation: fr_FR,
      },
      it: {
        translation: it_IT,
      },
      pl: {
        translation: pl_PL,
      },
      sk: {
        translation: sk_SK,
      },
    },
    partialBundledLanguages: true,
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
      prefix: '{',
      suffix: '}',
    },
    react: {
      useSuspense: true,
    },
    pluralSeparator: '.',
  });

export {i18n};
